/**
 * Home2 CTA Footer
 * Final call-to-action section.
 * 
 * @module components/home2/Home2CTA
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight, Code } from 'lucide-react';
import { CTA_FOOTER } from '../../data/home2Content';

const Home2CTA = () => {
  const navigate = useNavigate();

  return (
    <section className="container mx-auto px-4 py-16">
      <div className="max-w-3xl mx-auto text-center">
        <div className="bg-gradient-to-br from-indigo-600 to-purple-600 rounded-2xl p-8 md:p-12 text-white">
          <h2 className="text-2xl md:text-3xl font-bold mb-6">
            {CTA_FOOTER.headline}
          </h2>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <Button 
              size="lg"
              onClick={() => navigate('/sample-gallery')}
              className="bg-white text-indigo-600 hover:bg-slate-100 px-8 py-6 text-lg"
            >
              {CTA_FOOTER.primaryCTA}
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button 
              size="lg"
              variant="outline"
              onClick={() => navigate('/compiler')}
              className="border-white/30 text-white hover:bg-white/10 px-8 py-6 text-lg"
            >
              <Code className="mr-2 h-5 w-5" />
              {CTA_FOOTER.secondaryCTA}
            </Button>
          </div>
          
          <div className="pt-6 border-t border-white/20">
            <p className="text-lg italic text-white/90 mb-2">
              "{CTA_FOOTER.quote}"
            </p>
            <p className="text-sm text-white/70">
              — {CTA_FOOTER.quoteSource}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home2CTA;
